import { Routes, Route } from "react-router-dom";
import Home from "./components/HomeComponent/Home";
import AboutUs from "./components/Pages/AboutUs";
import ContactUs from "./components/Pages/ContactUs";
import OurServices from "./components/Pages/OurServices";
import RequestQuote from "./components/Pages/RequestQuote";
import PrivacyPolicyPage from "./components/Pages/PrivacyPolicy";
import Navbar from "./components/Generic/Navbar";
import Footer from "./components/Generic/Footer";
import ScrollToTop from "./components/Components/ScrollToTop";
import MaintenancePage from "./components/Components/MaintenancePage";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    fetch(
      "https://trademinwebapp-g5atgdgehba7dpbb.westus2-01.azurewebsites.net/api/Integration",
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("Backend response:", data);
      })
      .catch((err) => {
        console.error("Error calling backend:", err);
      });
  }, []); // empty dependency array = run once

  // Check if the current hostname is your public domain
  const hostname = window.location.hostname.toLowerCase();
  const isBlockedDomain = hostname === "xxxxxx" || hostname === "xxxxxxxxxxx";

  if (isBlockedDomain) {
    return <MaintenancePage />;
  }

  return (
    <div className="my">
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-services" element={<OurServices />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/request-quote" element={<RequestQuote />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
